export default __webpack_public_path__ + "static/media/your-job-keeps-you-from-getting-work-done.9e581632.md";